(function () {
  'use strict';

  function initialisePalladioPage(root) {
    if (!root || root.dataset.palladioInitialised === 'true') return;
    root.dataset.palladioInitialised = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nav = root.querySelector('[data-pd-nav]');
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-pd-nav-link]'));
    var cleanups = [];

    function updateNav() {
      if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 24);
    }

    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });
    cleanups.push(function () { window.removeEventListener('scroll', updateNav); });

    if ('IntersectionObserver' in window) {
      var observedSections = navLinks.map(function (link) {
        var selector = link.getAttribute('href');
        return selector && selector.charAt(0) === '#' ? root.querySelector(selector) : null;
      }).filter(Boolean);

      var navObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          navLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      }, { rootMargin: '-45% 0px -48% 0px' });

      observedSections.forEach(function (section) { navObserver.observe(section); });
      cleanups.push(function () { navObserver.disconnect(); });
    }

    var reveals = Array.prototype.slice.call(root.querySelectorAll('.pd-reveal'));
    if (reducedMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (element) { element.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      reveals.forEach(function (element) { revealObserver.observe(element); });
      cleanups.push(function () { revealObserver.disconnect(); });
    }

    var carousel = root.querySelector('[data-pd-carousel]');
    if (carousel) {
      var track = carousel.querySelector('[data-pd-track]');
      var previous = carousel.querySelector('[data-pd-previous]');
      var next = carousel.querySelector('[data-pd-next]');

      function scrollCarousel(direction) {
        if (!track) return;
        track.scrollBy({
          left: direction * Math.max(280, track.clientWidth * 0.72),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      if (previous) previous.addEventListener('click', function () { scrollCarousel(-1); });
      if (next) next.addEventListener('click', function () { scrollCarousel(1); });
    }

    var configurator = root.querySelector('[data-pd-configurator]');
    if (configurator) {
      var colourName = configurator.querySelector('[data-pd-colour-name]');
      var glassName = configurator.querySelector('[data-pd-glass-name]');
      var hardwareName = configurator.querySelector('[data-pd-hardware-name]');
      var badge = configurator.querySelector('[data-pd-door-badge]');
      var summary = configurator.querySelector('[data-pd-summary]');
      var doorImage = configurator.querySelector('[data-pd-door-image]');

      function selectionText() {
        return [
          colourName ? colourName.textContent : '',
          glassName ? glassName.textContent + ' glazing' : '',
          hardwareName ? hardwareName.textContent : ''
        ].filter(Boolean).join(' · ');
      }

      function updateSummary() {
        if (summary) summary.textContent = selectionText();
      }

      Array.prototype.slice.call(configurator.querySelectorAll('button[data-pd-colour]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var colour = button.dataset.pdColour;
          var label = button.dataset.pdLabel;

          configurator.querySelectorAll('button[data-pd-colour]').forEach(function (item) {
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          if (doorImage && doorImage.dataset.pdColour !== colour) {
            doorImage.srcset = button.dataset.pdSrcset;
            doorImage.src = button.dataset.pdSrc;
            doorImage.alt = button.dataset.pdAlt;
            doorImage.dataset.pdColour = colour;
          }
          if (colourName) colourName.textContent = label;
          if (badge) badge.textContent = label;
          updateSummary();
        });
      });

      ['glass', 'hardware'].forEach(function (group) {
        Array.prototype.slice.call(configurator.querySelectorAll('[data-pd-' + group + ']')).forEach(function (button) {
          button.addEventListener('click', function () {
            configurator.querySelectorAll('[data-pd-' + group + ']').forEach(function (item) {
              item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
            });
            var target = group === 'glass' ? glassName : hardwareName;
            if (target) target.textContent = button.dataset.pdLabel;
            updateSummary();
          });
        });
      });

      updateSummary();
    }

    var engineering = root.querySelector('[data-pd-engineering]');
    if (engineering && 'IntersectionObserver' in window) {
      var chapters = Array.prototype.slice.call(engineering.querySelectorAll('[data-pd-chapter]'));
      var currentIndex = engineering.querySelector('[data-pd-engineering-index]');
      var currentSpec = engineering.querySelector('[data-pd-engineering-spec]');
      var engineeringMedia = window.matchMedia('(min-width: 821px)');
      var chapterObserver = null;

      function activateChapter(chapter) {
        chapters.forEach(function (item) {
          item.classList.toggle('is-active', item === chapter);
        });
        if (currentIndex) currentIndex.textContent = chapter.dataset.pdIndex;
        if (currentSpec) currentSpec.textContent = chapter.dataset.pdSpec;
      }

      function configureEngineering() {
        if (chapterObserver) {
          chapterObserver.disconnect();
          chapterObserver = null;
        }

        if (!engineeringMedia.matches) {
          if (chapters[0]) activateChapter(chapters[0]);
          return;
        }

        chapterObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) activateChapter(entry.target);
          });
        }, { rootMargin: '-44% 0px -44% 0px' });

        chapters.forEach(function (chapter) { chapterObserver.observe(chapter); });
      }

      configureEngineering();
      if (engineeringMedia.addEventListener) {
        engineeringMedia.addEventListener('change', configureEngineering);
        cleanups.push(function () { engineeringMedia.removeEventListener('change', configureEngineering); });
      } else {
        engineeringMedia.addListener(configureEngineering);
        cleanups.push(function () { engineeringMedia.removeListener(configureEngineering); });
      }
      cleanups.push(function () {
        if (chapterObserver) chapterObserver.disconnect();
      });
    }

    root._palladioCleanup = function () {
      cleanups.forEach(function (cleanup) { cleanup(); });
      root.dataset.palladioInitialised = 'false';
    };
  }

  function initialiseAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('.palladio-page')).forEach(initialisePalladioPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.palladio-page');
    if (root && root._palladioCleanup) root._palladioCleanup();
  });
}());
